import { CredentialsSignin } from 'next-auth';

/**
 * Mã lỗi xác thực bằng AuthJS
 */
export enum AuthErrorCode {
    /**Sai thông tin tài khoản hoặc mật khẩu */
    InvalidCredentials = 'InvalidCredentials',

    /**Tài khoản bị khóa */
    AccountLocked = 'AccountLocked',

    /**
     * Không vào đúng site theo loại tài khoản
     * @description Ví dụ: Tài khoản sinh viên không vào được trang quản trị
     */
    Forbidden = 'Forbidden',

    /**
     * Tài khoản cán bộ không hợp lệ
     */
    ErrorCivilServant = 'ErrorCivilServant',

    /**
     * Không tìm thấy tài nguyên
     */
    Google_NotFound = 'NotFound',

    /**
     * Tài khoản lỗi bussiness không được login
     */
    Google_BusinessRequired = 'BusinessRequired',

    /**
     * Đăng nhập SSO nhưng tài khoản chưa được cấu hình/duyệt trên hệ thống
     */
    SSO_NotProvisioned = 'SsoNotProvisioned',

    /**
     * SSO tạm thời không phản hồi (timeout/mạng/5xx) khi đổi token — nên thử lại.
     */
    SSO_Unavailable = 'SsoUnavailable',
}

/**
 * Sai thông tin tài khoản hoặc mật khẩu
 */
export class InvalidCredentials extends CredentialsSignin {
    code = AuthErrorCode.InvalidCredentials;
}

/**Khóa tài khoản */
export class AccountLocked extends CredentialsSignin {
    code = AuthErrorCode.AccountLocked;
}

export class ForbiddenCredentials extends CredentialsSignin {
    code = AuthErrorCode.Forbidden;
}
